import React from 'react';
import PropTypes from 'prop-types';
import {Alert}from 'react-bootstrap';
import ConsoleLog from '../../hoc/ConsoleLog/ConsoleLog';
/**
* @desc  Shows Confirmation Field to send the verification mail with the user mail-id
* @version 1.0.1
* @author  Lakshmikanth,Amrutha KK
*/
class ConfirmForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      verificationCode: '',
    };
  }
/**
 * @desc Save the user mail-id  to send the verification code
 * @param event
 * @return null
 */
  onSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.verificationCode.trim())
     .then((user) => {
      //ConsoleLog(user);
     })
     .catch((error) => {
      console('error',error);
       this.setState({ error });
     });
  }
/**
 * @desc Resend  the verification code to given user mail-id
 * @param event
 * @return null
 */
  onResend = (event) => {
    event.preventDefault();
    this.props.onResend()
     .then((user) => {
       this.setState({ error: 'Code resent' });
     })
     .catch((error) => {
      ConsoleLog('error',error);
       this.setState({ error });
     });

  }
/**
 * @desc Fill  the verification code to given user mail-id
 * @param event
 * @return null
 */
  changeVerificationCode = (event) => {
    this.setState({ verificationCode: event.target.value });
  }

  render = () => (
    <form onSubmit={this.onSubmit}>
      <Alert bsStyle="danger" className="error-message">{this.state.error}</Alert>
      <label>
        Verification Code
        <input placeholder="code" onChange={this.changeVerificationCode} required />
      </label>
      <button type="submit">Submit</button>
      <button type="button" onClick={this.onResend}>Resend code</button>
      <button type="button" onClick={this.props.onCancel}>Cancel</button>

    </form>
  )
}
ConfirmForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onResend: PropTypes.func,
  error: PropTypes.string,
};

export default ConfirmForm;



// WEBPACK FOOTER //
// ./src/components/Authentication/ConfirmForm.js